import { create } from 'zustand';

const useDialogStore = create((set) => ({
  openDialog2: false,
  invoiceNo: '',
  dueAmount: 0,
  dialogShown: false, // <-- add this flag

  showDialog: (invoiceNo, dueAmount) =>
    set((state) => {
      if (state.dialogShown) return {}; // prevent reopening
      return {
        openDialog2: true,
        invoiceNo,
        dueAmount,
        dialogShown: true, // mark as shown
      };
    }),

  closeDialog2: () => set({ openDialog2: false }),

  resetDialog: () => set({ dialogShown: false }), // optional, if you need to re-enable it
}));

export { useDialogStore };
